var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListIconAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11526_18685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 13.9285V15.3571H11.3888V13.9285H1.66663Z",
    fill: "#374E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10.3571V2.5H2.36107V13.2142H13.4722V11.7857H3.74996V3.92857H14.8611V10.3571H16.25Z",
    fill: "#374E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7777 13.9286H14.8611V15.3572C13.7763 15.3572 12.7777 15.3572 12.7777 15.3572V13.9286Z",
    fill: "#374E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 11.7857V17.5H14.8611V11.7857H16.25Z",
    fill: "#374E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13.9286H18.3333V15.3572C17.2485 15.3572 16.25 15.3572 16.25 15.3572V13.9286Z",
    fill: "#374E92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11526_18685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconAsset);
export default __webpack_public_path__ + "static/media/list_icon_asset.6d4a3a21fc47ccf1c42e048d3a31e060.svg";
export { ForwardRef as ReactComponent };